<template>
    <div class="agri-platform-container">
        <div class="top-title">
            <h2>芯棚智云数智农业管理系统</h2>
        </div>
        <!-- 主体内容区域 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="11">
                <img :src="dashboardImg" alt="芯棚智云数智农业管理系统" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="13">
                <div class="desc-card">
                    <p>
                        作为宁夏芯棚到家科技有限公司倾力打造的数智农业管理利器，系统以“物联网+大数据+远程控制”为核心，整合设备管理、数据分析、视频监控、农场管控、系统配置五大核心模块，覆盖从设备运行、环境监测到农场运营的全场景需求。
                    </p>
                    <p>
                        无需复杂操作，通过网页端即可实现对温室大棚、农田地块的远程管控，实时掌握土壤温湿度、水肥流量、设备状态等关键数据，让农业生产告别“凭经验、靠人力”，迈入“精准化、高效化、智能化”新时代，助力农户降本增效、农场规模化管理。
                    </p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'AgriPlatformPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/Mainsoftware/xpzy.png')

        }
    }
}
</script>